export default (axios, checkHeaders) => ({
  getList (data = {}) {
    return axios.get('/invoice-recurrences', { params: data.filters || {} })
  },
  postOne (data = {}) {
    return axios.post('/invoice-recurrence', data.body, { params: data.filters || {} })
  },
  getOne (data = {}) {
    return axios.get('/invoice-recurrence/' + data.id, { params: data.filters || {} })
  },
  patchOne (data = {}) {
    return axios.patch('/invoice-recurrence/' + data.id, data.body, { params: data.filters || {} })
  },
  deleteOne (data = {}) {
    return axios.delete('/invoice-recurrence/' + data.id, { params: data.filters || {} })
  }
})
